<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success" v-if="false">
          <div
            class="box-header with-border"
            v-show="true"
            style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;"
          >
            <h3 class="box-title">{{$t('search.title')}}</h3>
            <!-- <lte-button
              style="float:right; display:block;"
              type="btn btn-primary"
              right_icon="fa fa-plus"
              @click="addNew($event)"
            >{{$t('common.add')}}</lte-button>-->
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-12 col-ld-12 col-sd-12">
                <!-- Search date_from -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar">
                          <label>
                            <span
                              style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span>
                          </label>
                        </i>
                      </div>
                      <date-picker
                        :config="options"
                        :value="search.from_date"
                        v-model="search.from_date"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <!-- END Search date_from -->

                <!-- Search date_to -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar">
                          <label>
                            <span
                              style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span>
                          </label>
                        </i>
                      </div>
                      <date-picker
                        :config="options"
                        :value="search.to_date"
                        v-model="search.to_date"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <!-- END - Search date_to -->

                <div class="col-sm-4 col-md-4 col-lg-4">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('receipt.user_created')"
                    v-model="search.user_created"
                  />
                </div>
              </div>

              <div v-if="false">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-tachometer"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('receipt.receipt_code')"
                      v-model="search.receipt_code"
                      v-on:keyup.enter="onSearchReceipt"
                    />
                  </div>
                </div>
                <!--
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('receipt.from_invoice')"
                    v-model="search.from_invoice"
                    v-on:keyup.enter="onSearchReceipt"
                  />
                </div>
                -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('receipt.apartment_code')"
                    v-model="search.apartment_code"
                    v-on:keyup.enter="onSearchReceipt"
                  />
                </div>
              </div>

              <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                <input type="text" class="form-control" :placeholder="$t('receipt.from_invoice')" v-model="search.receipt_created" v-on:keyup.enter="onSearchReceipt">
              </div>-->
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchReceipt"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
                <button type="button" class="btn btn-default pull-right" @click="onExport">
                  <span class="btn-label">
                    <i class="fa fa-download"></i>
                  </span>
                  {{$t('customer.export')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <ul class="nav nav-tabs">
                <li class="nav active">
                  <a data-toggle="tab" href="#periodicTask" @click="onTabChange('periodicTask')"
                    ><h3 class="box-title">{{ $t("batch_job.periodic_title") }}</h3></a
                  >
                </li>
                <li class="nav">
                  <a data-toggle="tab" href="#batchjobshowlist" @click="onTabChange('batchJobShowList')"
                    ><h3 class="box-title">{{ $t("batch_job.title") }}</h3></a
                  >
                </li>
                <li>
                  <a data-toggle="tab" href="#batchjobhistory"  @click="onTabChange('batchJobHistory')"
                    ><h3 class="box-title">
                      {{ $t("batch_job.history_list") }}
                    </h3></a
                  >
                </li>
              </ul>

              <lte-button
                v-if="false"
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-print"
                @click="onPrintByFilter($event)"
              >{{$t('common.printPdf')}}</lte-button>
            </div>
            <select-option-check
              v-if="false"
              @callbackData="saveCustomizeTable"
              style="margin-top:-40px;"
              :item="columnsReceipt"
              class="dropdown-trigger"
              data-icon="eye"
            ></select-option-check>
          </div>
          <div class="box-body">
            <div class="tab-content">
              <div id="periodicTask" class="tab-pane fade in active">
                <batchJob-periodictask ref="periodicTask" />
              </div>
              <div id="batchjobshowlist" class="tab-pane fade">
                <batchJob-showlist ref="batchJobShowList" />
              </div>
              <div id="batchjobhistory" class="tab-pane fade">
                <batchJob-history ref="batchJobHistory" />
              </div>
            </div>
          </div>
        </div>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import i18n from "../../lang";
import datePicker from "vue-bootstrap-datetimepicker";
import BatchJobShowList from "./BatchJobShowList";
import Batchjobhistory from "./BatchJobhistory";
import BatchJobPeriodicTask from "./BatchJobPeriodicTask";
import utils from '@/lib/utils'
// import XLSX from "xlsx";

export default {
  name: "BatchJobList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      // gridReceiptDataList: [],
      columnsReceipt: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      dateOptions: {
        format: "DD-MM-YYYY hh:mm a"
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      onSearching: 1,
      search: {
        apartment_code: "",
        from_date: null,
        to_date: null,
        user_created: ""
      },
      isLoading: false,

      useCheckBox: false,
      used_wallet: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_RECEIPT_DATA",
      "GET_BATCH_JOB_LIST_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  methods: {
     onTabChange: function (tabType) {
      if (tabType == 'batchJobShowList') {
        this.$refs.batchJobShowList.onBatchJobShowList()
        this.onSearching = 1
      } else {
        this.$refs.batchJobHistory.onBatchJobHistory()
        this.onSearching = 2
      }
    },


    getFullNameUserCreate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    getFullNameUserUpdate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },

    onExport: function() {
    },

    onPrintByFilter: function() {
      // let routeData = this.$router.resolve({
      //   name: "ReceiptPdfFilter",
      //   query: {
      //     ids: this.list_receipt_id.join(",")
      //   }
      // });
      // window.open(routeData.href, "_blank");
    },
    selectedItems: function(list_receipt_id) {
      // this.list_receipt_id = list_receipt_id;
    },

    getFullNameByLanguage(first_name, last_name) {
      if (data != null) {
        return utils.getFullName(first_name, last_name, i18n.locale);
      }
      return "";
    },
    onSearchReceipt: function() {
     if (this.onSearching == 1)
     this.$refs.batchJobShowList.onSearchReceipt(this.search.from_date, this.search.to_date,this.search.user_created)
     else{
     this.$refs.batchJobHistory.onSearchReceipt(this.search.from_date, this.search.to_date,this.search.user_created)
     }
    },
    saveCustomizeTable: function(tables) {
      // let tableDataObj = {};
      // let tableDataObjChild = {};
      // tableDataObjChild["tablename"] = "receiptlist";
      // tables.data_list.forEach(element => {
      //   tableDataObj[element.text] = element.isHidden;
      // });
      // tableDataObjChild["tablerow"] = tableDataObj;
      // this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
      //   .then(
      //     function() {
      //       this.SUCCESS_TOAST();
      //     }.bind(this)
      //   )
      //   .catch(
      //     function() {
      //       this.ERROR_TOAST();
      //     }.bind(this)
      //   );
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {
      // this.$router.push({
      //   name: "BatchJobtAdd",
      //   params: {
      //     id: 0
      //   }
      // });
    },
  
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      // "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG"
    ])
  },
  mounted() {},

  components: {
    "date-picker": datePicker,
    "lte-button": LTEButton,
    "select-option-check": SelectOptionCheck,
    "batchJob-showlist": BatchJobShowList,
    "batchJob-history": Batchjobhistory,
    "batchJob-periodictask": BatchJobPeriodicTask,
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Project/BatchJobList.vue